import React from 'react';
import { Formik } from 'formik';
import { useStore } from 'hooks';
import { Button } from 'components/ui/form';
import { Input } from 'components/ui/formik';
import AuthHelper from 'helpers/auth';
import styles from './login.module.scss';
import logoSi from '../../../assets/images/logo_si.png';
import patternImg from '../../../assets/images/pattern-left-side.png';

const LoginPage = ({ history }) => {
  const { setLoading, setUser } = useStore();
  const patternStyle = { backgroundImage: `url(${patternImg})` };

  return (
    <main className="page-login">
      <Formik
        initialValues={{
          inn: '',
          password: '',
        }}
        onSubmit={({ inn, password }) => {
          AuthHelper.login(
            inn,
            password,
            { setLoading, setUser },
          );
        }}
      >
        {({
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit} className={styles.login} autoComplete="off">
            <div className={styles.head}>
              <div className={styles.title}>Добро пожаловать!</div>
              <img src={logoSi} alt="Гранит" className={styles.logo} />
            </div>
            <div className={styles.fields}>
              <div className={styles.field}>
                <Input name="inn" placeholder="Логин" />
              </div>
              <div className={styles.field}>
                <Input name="password" type="password" placeholder="Пароль" />
              </div>
            </div>
            <div className={styles.actions}>
              <div className={styles.restore}>
                <Button
                  color="transparent"
                  onClick={() => history.push('/restore')}
                >
                  Забыли пароль?
                </Button>
              </div>
              <div className={styles.submit}>
                <Button type="submit">Войти</Button>
              </div>
            </div>
          </form>
        )}
      </Formik>
      <div className={styles.patternBottomRight} style={patternStyle} />
    </main>
  );
};

export default LoginPage;
